/**
 * Created by agengmaulana on 1/25/17.
 */
import React  from 'react'
import Pagination from 'react-js-pagination'
import {observer} from "mobx-react"


@observer
export default class  Comment_Pagination extends React.Component{
    constructor(props) {
        super(props);
    }


    render() {
        let totalPages = Math.ceil(this.props.dataStore.paging.item / 10);
        const activepage = parseInt(this.props.dataStore.position)
        return (
            <Pagination
                // prev
                // next
                // ellipsis
                // boundaryLinks
                // items={totalPages}
                // maxButtons={5}
                // activePage={activepage}
                // onSelect={this.props.dataStore.handleSelect}
                //
                innerClass={"cmt_pagination"}
                itemClass={"cmt_li"}
                linkClass={"cmt_a"}
                activePage={activepage}
                itemsCountPerPage={10}
                totalItemsCount={this.props.dataStore.paging.item}
                pageRangeDisplayed={5}
                onChange={this.props.dataStore.handleSelect}
            />
        );
    }



}



// WEBPACK FOOTER //
// ./static/src/component/comment_pagination/comment_pagination.js